module.exports = __webpack_public_path__ + "static/media/2030117000.d66c4504.jpg";